'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var jsxRuntime = require('react/jsx-runtime');
var Input = require('../alloy-input/Input.js');
var cx = require('classnames');
var alloyDropdown_module = require('./alloy-dropdown.module.scss.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var cx__default = /*#__PURE__*/_interopDefault(cx);

var SingleItemDropdown = function (_a) {
    var className = _a.className, getLabel = _a.getLabel, id = _a.id, internalError = _a.internalError, items = _a.items, itemToString = _a.itemToString, name = _a.name, rest = tslib.__rest(_a, ["className", "getLabel", "id", "internalError", "items", "itemToString", "name"]);
    return (jsxRuntime.jsx(Input.default, tslib.__assign({ label: getLabel(), id: id, name: name, value: itemToString(items[0]), readOnly: true, className: cx__default.default("".concat(alloyDropdown_module.default['no-caret']), "".concat(alloyDropdown_module.default['dropdown__one-item']), 'ps-0', 'border-0', className), disabled: true, tabIndex: -1, error: internalError }, rest)));
};
var SingleItemDropdown$1 = SingleItemDropdown;

exports.default = SingleItemDropdown$1;
//# sourceMappingURL=SingleItemDropdown.js.map
